import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import { AdminLayout } from '../components/admin/AdminLayout';
import { ProtectedRoute } from './ProtectedRoute';

// Public Pages
import { HomePage as PublicHomePage } from '../pages/Home/HomePage';
import { ProductsPage as PublicProductsPage } from '../pages/Products/ProductsPage';
import { ProductDetailPage } from '../pages/Products/ProductDetailPage';
import { AboutPage } from '../pages/About/AboutPage';
import { QualityPage } from '../pages/Quality/QualityPage';
import { ContactPage } from '../pages/Contact/ContactPage';
import { BlogPage } from '../pages/Blog/BlogPage';
import { BlogDetailPage } from '../pages/Blog/BlogDetailPage';

// Admin Auth Pages
import { AdminLogin } from '../pages/Admin/AdminLogin';
import { ForgotPassword } from '../pages/Admin/ForgotPassword';

// Admin Dashboard
import { AdminDashboard } from '../pages/Admin/AdminDashboard';

// Admin Users
import { UsersPage } from '../pages/Admin/Users/UsersPage';
import { UserDetailPage } from '../pages/Admin/Users/UserDetailPage';
import { ProfilePage } from '../pages/Admin/Users/ProfilePage';

// Admin Settings

import { CompanyInfoPage } from '../pages/Admin/Settings/CompanyInfoPage';
import { SocialMediaPage } from '../pages/Admin/Settings/SocialMediaPage';
import { SEOPage } from '../pages/Admin/Settings/SEOPage';
import { EmailSettingsPage } from '../pages/Admin/Settings/EmailSettingsPage';

// Admin Gallery - Properly named to avoid conflicts
import { HeaderPage } from '../pages/Admin/ManageGallery/Header/HeaderPage';

import { Products } from '../pages/Admin/ManageGallery/Products/Products';
import { InternationalPage } from '../pages/International/InternationalPage';
import { CertificationsPage } from '../pages/Certifications/CertificationsPage';
import { ContactUsPage } from '../pages/Admin/ManageGallery/ContactUs/ContactUsPage';

// Admin Security
import { TwoFactorPage } from '../pages/Admin/Security/TwoFactorPage';
import { ChangePasswordPage } from '../pages/Admin/Security/ChangePasswordPage';
import { RecoveryCodesPage } from '../pages/Admin/Security/RecoveryCodesPage';
import { LoginHistoryPage } from '../pages/Admin/Security/LoginHistoryPage';
import { ApiKeysPage } from '../pages/Admin/Security/ApiKeysPage';
import { OurProducts } from '../components/home/OurProducts';
import { ManageThemePage } from '../pages/Admin/ManageTheme/ManageThemePage';
import { AboutUsGalleryPage } from '../pages/Admin/ManageGallery/AboutUs/AboutUsGalleryPage';
import { CertificationsGalleryPage } from '../pages/Admin/ManageGallery/Certifications/CertificationsGalleryPage';
import { QualityProcessGalleryPage } from '../pages/Admin/ManageGallery/QualityProcess/QualityProcessGalleryPage';
import { PackagingGalleryPage } from '../pages/Admin/ManageGallery/PackagingGallery/PackagingGalleryPage';
import { HeroGalleryPage } from '../pages/Admin/ManageGallery/HeroGallery/HeroGalleryPage';
import { BlogGalleryPage } from '../pages/Admin/ManageGallery/BlogGallery/BlogGalleryPage';


export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* ========== PUBLIC ROUTES ========== */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<PublicHomePage />} />
        <Route path="/products" element={<PublicProductsPage />} />
        <Route path="/products/:slug" element={<ProductDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/international" element={<InternationalPage />} />
        <Route path="/quality" element={<QualityPage />} />
        <Route path="/certifications" element={<CertificationsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
      </Route>

      {/* ========== ADMIN AUTH ROUTES ========== */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/forgot-password" element={<ForgotPassword />} />

      {/* ========== PROTECTED ADMIN ROUTES ========== */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        {/* Dashboard */}
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="theme" element={<ManageThemePage />} />
        {/* Users Management */}
        <Route path="users">
          <Route index element={<UsersPage />} />
          <Route path=":id" element={<UserDetailPage />} />
        </Route>
        <Route path="profile" element={<ProfilePage />} />
        
<Route path="gallery/about-us" element={<AboutUsGalleryPage />} />
<Route path="gallery/certifications" element={<CertificationsGalleryPage />} />
<Route path="gallery/quality-process" element={<QualityProcessGalleryPage />} />
<Route path="gallery/packaging" element={<PackagingGalleryPage />} />
<Route path="gallery/hero" element={<HeroGalleryPage />} />
<Route path="gallery/blog" element={<BlogGalleryPage />} />

        {/* Security Routes */}
        <Route path="security">
          <Route index element={<Navigate to="2fa" replace />} />
          <Route path="2fa" element={<TwoFactorPage />} />
          <Route path="password" element={<ChangePasswordPage />} />
          <Route path="recovery" element={<RecoveryCodesPage />} />
          <Route path="history" element={<LoginHistoryPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
        </Route>
        
        {/* Gallery Management */}
        <Route path="gallery">
          <Route path="header" element={<HeaderPage />} />
          
          <Route path="ourproducts" element={<OurProducts />} />
          <Route path="products" element={<Products />} />
          
          <Route path="international" element={<InternationalPage />} />
          <Route path="certifications" element={<CertificationsPage />} />
          <Route path="contact" element={<ContactUsPage />} />
        </Route>
        
        {/* Settings Routes */}
        <Route path="settings">
          <Route index element={<Navigate to="general" replace />} />
         
          <Route path="company" element={<CompanyInfoPage />} />
          <Route path="social" element={<SocialMediaPage />} />
          <Route path="seo" element={<SEOPage />} />
          <Route path="email" element={<EmailSettingsPage />} />
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Route>
    </Routes>
  );
};